function onPageEnter(){

  function pageEnter(){

    // scroll to 0 instant
    bus.emit('scrollto', 0, 0)// target, duration, ease

    $('html').removeClass('js-pagetransi')

    // animation
    const tl = gsap.timeline()



    if (pageTransiType === 'specific-transition') {
      // specific transition
    } else {
      // regular transition
    }

    tl.fromTo($('.mainpage'), 1.6, {autoAlpha:0}, {autoAlpha:1, ease:'power3.out'}, 0.5)



    // firstLoad
    if (typeof window.firstLoad !== 'undefined') {
      // pageload bar
      gsap.killTweensOf($('.pageload'))
      tl.to($('.pageload'), .6, {x:'0%', ease:'expo.inOut'}, 0)
      tl.to($('.pageload'), 1.2, {y:'-101%', ease:'power2.inOut'}, 1)
    }
    window.firstLoad = false


    // allow scrollReveal
    setTimeout(function(){
      window.preventScrollReveal = false
      bus.emit('checkScrollReveal', 'fromPageEnter')
    }, 1000)
  }
  bus.on('pageEnter', pageEnter)

}
export default onPageEnter